import type { ReactNode } from "react";
import { chip, type ChipTone } from "@web/theme/theme";

export type StatusChipProps = { tone?: ChipTone; icon?: ReactNode; className?: string; children: ReactNode };

export function StatusChip({ tone = "neutral", icon, className = "", children }: StatusChipProps) {
  return (
    <span className={`${chip.base} ${chip.tone[tone]} ${className}`.trim()}>
      {icon}
      {children}
    </span>
  );
}
